import React, { Component } from 'react';
import moment from 'moment';
import { debounce } from 'lodash'
import Dialog, { DialogActions, DialogContent, DialogTitle } from 'material-ui/Dialog';
import Icon from 'material-ui/Icon';
import { CircularProgress } from 'material-ui/Progress';
import Snackbar from 'material-ui/Snackbar';
import { withStyles } from 'material-ui/styles';
import Table, { TableBody, TableCell, TableHead, TableRow, TableSortLabel } from 'material-ui/Table';
import Tooltip from 'material-ui/Tooltip';
import { VictoryAxis, VictoryBrushContainer, VictoryChart, VictoryLine, VictoryZoomContainer } from 'victory';
import { get } from '../../services/apiServices';
import { token } from '../../services/authServices';
import { LevelComponent } from '../game/level.components';
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { InputLabel } from "material-ui/Input";
import TextField from 'material-ui/TextField'

const styles = {
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	editIcon: {
		padding: '10px',
		cursor: 'pointer'
	},
	icon: {
		marginLeft: '10px',
		//marginTop: '10px'
	},
	button: {
		width: '120px',
		margin: '0 auto 40px'
	},
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	table: {
		minWidth: 700,
	},
	tableRow: {
		//cursor: 'pointer'
	},
	tableCellWithAction: {
		cursor: 'pointer'
	},
	clickable: {
		cursor: 'pointer'
	},
	listItem: {
		width: "480px",
		alignItems: "flex-start",
		borderBottom: "1px solid rgba(224, 224, 224, 1)"
	},
	listItemText: {
		flex: "1 1 50%"
	},
	listItemTtitle: {
		fontWeight: 600
	},
	progressWrapper: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	progress: {
	},
	vertical: {
		'transform': 'rotate(180deg)',
		'writing-mode': 'vertical-rl',
		'white-space': 'nowrap',
		'margin': '10px'
	},
	'rating-red': {
		color: 'red'
	},
	'rating-yellow': {
		color: '#fcd205'
	},
	'rating-green': {
		color: 'green'
	},
	svgContainer: {
		display: 'block'
	},
	Select: {
		minWidth: '200px',
		marginLeft: '10px',
		marginRight: '10px',
	},
	SelectMenu: {
		minWidth: '200px',
	},
};

class StoryModeComponent extends Component {
	state = {
		players: {},
		isFetching: false,
		openModal: false,
		level: null,
		order: 'asc',
		orderBy: 'name',
	}

	rows = [
		{
			id: 'name',
			title: 'NAME',
			sortable: true
		},
		{
			id: 'progress',
			title: 'PROGRESS',
			sortable: true
		},
		{
			id: 'avg_level_attempts',
			title: 'AVG ATTEMPTS',
			sortable: true
		},
		{
			id: 'current_level',
			title: 'STAGE & LEVEL',
			sortable: true
		},
		{
			id: 'current_level_attempts',
			title: 'CURRENT LEVEL ATTEMPTS',
			sortable: true
		},
		{
			id: 'last_play',
			title: 'LAST PLAYED',
			sortable: true
		}
	]

	classes = this.props.classes;

	componentWillMount() {
		this.getPlayers(1, this.props.accountId, this.props.classRoomId)
	}

	componentWillReceiveProps(props) {
		if (props.classRoomId !== undefined) {
			this.getPlayers(1, props.accountId, props.classRoomId)
		}
	}

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}

		this.setState({ order, orderBy });
	};

	getPlayers = (page, accountId, classRoomId) => {
		this.setState({ isFetching: true })
		return get(`/admin/reports/story-mode?page=${page}&accountId=${accountId}&classRoomId=${classRoomId ? classRoomId : ''}`, token).then(res => {
			let players = res.data
			this.setState({ players, isFetching: false })
		})
	}

	handleOpenModal = (level) => {
		this.setState({ level, openModal: true })
	}
	handleCloseModal = () => {
		this.setState({ openModal: false })
	}

	sortData = (data) => {
		let { order, orderBy } = this.state
		return data.sort((a, b) => {
			if (order === 'desc') {
				if(orderBy === 'current_level' && a['current_stage'] !== b['current_stage'])
					return a['current_stage'] > b['current_stage'] ? 1 : -1
				else
					return a[orderBy] > b[orderBy] ? 1 : -1
				
			} else {
				if(orderBy === 'current_level' && a['current_stage'] !== b['current_stage'])
					return a['current_stage'] > b['current_stage'] ? -1 : 1
				else
					return a[orderBy] > b[orderBy] ? -1 : 1
			}
		})
	}

	renderPlayersList = () => {
		let items = this.state.players ?
			this.state.players.data : []
		let result = []

		this.sortData(items).map(item => {
			result.push(
				<TableRow
					className={this.classes.tableRow}
					key={item.id}
					/* onClick={() => this.props.toUsers(item.id)} */>
					<TableCell padding='none'>
						{item.name}
					</TableCell>
					<TableCell padding='none'>
						{Math.round(item.progress)}%
					</TableCell>
					<TableCell padding='none'>
						{Math.round(item.avg_level_attempts * 10) / 10}
					</TableCell>
					<TableCell padding='none'>
						<span>{item.current_stage ? `${item.current_stage_name}-${item.current_level}` : '-'}</span>
						{item.current_level_data.id && <Icon
							title="Show level Information"
							className={[this.classes.icon, this.classes.clickable]}
							color="primary"
							onClick={() => { this.handleOpenModal(item) }}>
							search
							</Icon>}
					</TableCell>
					<TableCell padding='none'>
						<span>{item.current_level_attempts}</span>
						{item.max_attempts_exceeded ? <Icon title={`Over ${item.max_attempts ? item.max_attempts : 0} attempts made`} className={this.classes.icon} color="primary">report_problem</Icon> : null}
					</TableCell>
					<TableCell padding='none'>
						<span>{item.last_play ? moment.unix(item.last_play).format('DD/MM/YYYY HH:mm') : '-'}</span>
						{item.max_pause_exceeded ? <Icon title={`Hasn't logged on in a ${item.max_pause_days ? item.max_pause_days : 0} days`} className={this.classes.icon} color="primary">schedule</Icon> : null}
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	render() {
		let { order, orderBy, players, isFetching, level } = this.state

		return (
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress className={this.classes.progress} size={50} />
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					{this.state.openModal && <LevelPreview level={level} onClose={this.handleCloseModal} />}
					<div className={this.classes.titleWrap}>
						<h2 className={this.props.classes.title}>Story Mode Report</h2>
					</div>
					{
						players && players.data.length ?
							<Table className={this.classes.table}>
								<EnhancedTableHead
									rows={this.rows}
									order={order}
									orderBy={orderBy}
									onRequestSort={this.handleRequestSort}
								/>
								<TableBody>
									{this.renderPlayersList()}
								</TableBody>
							</Table>
							: null
					}
				</div>
		)
	}

}

class ChallengeModeComponent extends Component {
	state = {
		players: {},
		isFetching: false,
		openModal: false,
		level: null,
		order: 'asc',
		orderBy: 'name',
	}

	rows = [
		{
			id: 'name',
			title: 'NAME',
			sortable: true
		},
		/* {
			id: 'progress',
			title: 'PROGRESS',
			sortable: true
		}, */
		{
			id: 'avg_level_attempts',
			title: 'AVG ATTEMPTS',
			sortable: true
		},
		{
			id: 'current_level',
			title: 'LEVEL',
			sortable: true
		},
		{
			id: 'current_level_attempts',
			title: 'CURRENT LEVEL ATTEMPTS',
			sortable: true
		},
		{
			id: 'last_play',
			title: 'LAST PLAYED',
			sortable: true
		},
	]

	classes = this.props.classes;

	componentWillMount() {
		this.getPlayers(1, this.props.accountId, this.props.classRoomId)
	}

	componentWillReceiveProps(props) {
		if (props.classRoomId !== undefined) {
			this.getPlayers(1, props.accountId, props.classRoomId)
		}
	}

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}

		this.setState({ order, orderBy });
	};

	getPlayers = (page, accountId, classRoomId) => {
		this.setState({ isFetching: true })
		return get(`/admin/reports/challenge-mode?page=${page}&accountId=${accountId}&classRoomId=${classRoomId ? classRoomId : ''}`, token).then(res => {
			let players = res.data
			this.setState({ players, isFetching: false })
		})
	}

	handleOpenModal = (level) => {
		this.setState({ level, openModal: true })
	}
	handleCloseModal = () => {
		this.setState({ openModal: false })
	}

	sortData = (data) => {
		let { order, orderBy } = this.state
		return data.sort((a, b) => {
			if (order === 'desc') {
				return a[orderBy] > b[orderBy] ? 1 : -1
			} else {
				return a[orderBy] > b[orderBy] ? -1 : 1
			}
		})
	}

	renderPlayersList = () => {
		let items = this.state.players ?
			this.state.players.data : []
		let result = []

		this.sortData(items).map(item => {
			result.push(
				<TableRow
					className={this.classes.tableRow}
					key={item.id}
					/* onClick={() => this.props.toUsers(item.id)} */>
					<TableCell padding='none'>
						{item.name}
					</TableCell>
					{/* <TableCell padding='none'>
						{Math.round(item.progress)}
					</TableCell> */}
					<TableCell padding='none'>
						{Math.round(item.avg_level_attempts * 10) / 10}
					</TableCell>
					<TableCell padding='none'>
						<span>{item.current_level}</span>
						{item.current_level_data.id && <Icon
							title="Show level Information"
							className={[this.classes.icon, this.classes.clickable]}
							color="primary"
							onClick={() => { this.handleOpenModal(item.current_level_data) }}>
							search
							</Icon>}
					</TableCell>
					<TableCell padding='none'>
						<span>{item.current_level_attempts}</span>
						{item.max_attempts_exceeded ? <Icon title={`Over ${item.max_attempts ? item.max_attempts : 0} attempts made`} className={this.classes.icon} color="primary">report_problem</Icon> : null}
					</TableCell>
					<TableCell padding='none'>
						<span>{item.last_play ? moment.unix(item.last_play).format('DD/MM/YYYY HH:mm') : '-'}</span>
						{item.max_pause_exceeded ? <Icon title={`Hasn't logged on in a ${item.max_pause_days ? item.max_pause_days : 0} days`} className={this.classes.icon} color="primary">schedule</Icon> : null}
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	render() {
		let { order, orderBy, players, isFetching, level } = this.state
		return (
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress className={this.classes.progress} size={50} />
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					{/* <Dialog
						open={this.state.openModal}
						onClose={this.handleCloseModal}>
						<DialogTitle>
							<Icon
								className={this.classes.closeIcon}
								onClick={this.handleCloseModal}>
								close
							</Icon>
							<br />
							Level Information
						</DialogTitle>
						<DialogActions className={this.classes.justifyCenter}>
							<div dangerouslySetInnerHTML={{ __html: this.state.levelInfo }}></div>
						</DialogActions>
					</Dialog> */}
					{this.state.openModal && <LevelPreview level={level} onClose={this.handleCloseModal} />}
					<div className={this.classes.titleWrap}>
						<h2 className={this.props.classes.title}>Challenge Mode Summary Report</h2>
					</div>
					{
						players && players.data.length ?
							<Table className={this.classes.table}>
								<EnhancedTableHead
									rows={this.rows}
									order={order}
									orderBy={orderBy}
									onRequestSort={this.handleRequestSort}
								/>
								<TableBody>
									{this.renderPlayersList()}
								</TableBody>
							</Table>
							: null
					}
				</div>
		)
	}

}

class EffortComponent extends Component {
	state = {
		players: {},
		isFetching: false,
		levelInfo: null,
		order: 'asc',
		orderBy: 'name',
		openChart: false,
		chartOptions: {},
		timespan: '0',
		customTimespan: '',
		showCustomTimespan: false,
		gamemode: '0',
	}

	rows = [
		{
			id: 'name',
			title: 'NAME',
			sortable: true
		},
		{
			id: 'score_total',
			title: 'COINS EARNED',
			sortable: true
		},
		{
			id: 'correct_answers_total',
			title: 'QUESTIONS ANSWERED CORRECTLY',
			sortable: true
		},
		{
			id: 'accuracy',
			title: 'ACCURACY',
			sortable: true
		},
		{
			id: 'plays',
			title: 'GAMES PLAYED',
			sortable: true
		},
	]

	classes = this.props.classes;

	componentWillMount() {
		this.getPlayers(1, this.props.accountId, this.props.classRoomId)
	}

	componentWillReceiveProps(props) {
		if (props.classRoomId !== undefined) {
			this.getPlayers(1, props.accountId, props.classRoomId)
		}
	}

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}

		this.setState({ order, orderBy });
	};

	getPlayers = (page, accountId, classRoomId, timespan='', gamemode='') => {
		this.setState({ isFetching: true })
		return get(`/admin/reports/effort?accountId=${accountId}&classRoomId=${classRoomId ? classRoomId : ''}&timespan=${timespan}&gamemode=${gamemode}`, token).then(res => {
			let players = res.data
			this.setState({ players, isFetching: false })
		})
	}

	handleOpenChart = (chartOptions) => {
		this.setState({ openChart: true, chartOptions })
	}
	handleCloseChart = () => {
		this.setState({ openChart: false, chartOptions: {} })
	}

	sortData = (data) => {
		let { order, orderBy } = this.state
		if(orderBy === 'accuracy'){
			return data.sort((a, b) => {
				const firstVal = a.correct_answers_total / (a.correct_answers_total + a.incorrect_answers_total) * 100
				const secondtVal = b.correct_answers_total / (b.correct_answers_total + b.incorrect_answers_total) * 100
				if (order === 'desc') {
					if(isNaN(firstVal))
						return -1
					else if(isNaN(secondtVal))
						return 1
					else
						return firstVal > secondtVal ? 1 : -1
				} else {
					if(isNaN(firstVal))
						return 1
					else if(isNaN(secondtVal))
						return -1
					else
						return firstVal > secondtVal ? -1 : 1
				}
			})
		}else{
			return data.sort((a, b) => {
				if (order === 'desc') {
					return a[orderBy] > b[orderBy] ? 1 : -1
				} else {
					return a[orderBy] > b[orderBy] ? -1 : 1
				}
			})
		}
		
	}

	renderPlayersList = () => {
		let items = this.state.players ?
			this.state.players.data : []
		let result = []

		this.sortData(items).map(item => {
			let acuracy = Math.round((item.correct_answers_total / (item.correct_answers_total + item.incorrect_answers_total) * 100))
			result.push(
				<TableRow
					className={this.classes.tableRow}
					key={item.id}
					/* onClick={() => this.props.toUsers(item.id)} */>
					<TableCell padding='none'>
						{item.name}
					</TableCell>
					<TableCell className={this.classes.tableCellWithAction} padding='none' onClick={() => this.handleOpenChart({
						fetchFilters: { user_id: item.id },
						value: data => data.score_sum,
						settings: {}
					})}>
						{item.score_total}
					</TableCell>
					<TableCell className={this.classes.tableCellWithAction} padding='none' onClick={() => this.handleOpenChart({
						fetchFilters: { user_id: item.id },
						value: data => data.correct_answer_count_sum,
						settings: {}
					})}>
						{item.correct_answers_total}
					</TableCell>
					<TableCell className={this.classes.tableCellWithAction} padding='none' onClick={() => this.handleOpenChart({
						fetchFilters: { user_id: item.id },
						value: data => data.correct_answer_count_sum / (data.correct_answer_count_sum + data.incorrect_answer_count_sum) * 100,
						settings: {}
					})}>
						{acuracy ? acuracy + '%' : '-'}
					</TableCell>
					<TableCell className={this.classes.tableCellWithAction} padding='none' onClick={() => this.handleOpenChart({
						fetchFilters: { user_id: item.id },
						value: data => data.plays_qty,
						settings: {}
					})}>
						{item.plays}
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	handleTimespanChange = (event) => {
		let showCustomTimespan = false
		if(event.target.value === 'custom'){
			showCustomTimespan = true
		}else{
			this.getPlayers(1, this.props.accountId, this.props.classRoomId, event.target.value, this.state.gamemode)
		}
		this.setState({ timespan: event.target.value, showCustomTimespan })
		
	}

	handleCustomTimespanChange = (event) => {
		this.setState({ customTimespan: event.target.value })
		this.getPlayersDebonce(1, this.props.accountId, this.props.classRoomId, event.target.value, this.state.gamemode)
	}

	handleGamemodeChange = (event) => {
		this.setState({ gamemode: event.target.value })
		this.getPlayers(1, this.props.accountId, this.props.classRoomId, this.state.timespan === 'custom' ? this.state.customTimespan : this.state.timespan, event.target.value)
	}

	getPlayersDebonce = debounce((page, accountId, classRoomId, timespan, gamemode) => {
        this.getPlayers(page, accountId, classRoomId, timespan, gamemode)
    }, 500)

	render() {
		let { order, orderBy, players, isFetching, openChart, chartOptions, timespan, customTimespan, showCustomTimespan, gamemode } = this.state
		return (
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress className={this.classes.progress} size={50} />
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					<div className={this.classes.titleWrap}>
						<h2 className={this.props.classes.title}>Effort Report</h2>
						<div>
							<InputLabel htmlFor="stage-select">
								Timespan
                            </InputLabel>
							<Select
								style={styles.Select}
								value={timespan}
								onChange={this.handleTimespanChange}
								autoWidth
							>
								<MenuItem value="0" style={styles.SelectMenu}>
									All time
                                </MenuItem>
								<MenuItem value="1" style={styles.SelectMenu}>
									Today
                                </MenuItem>
								<MenuItem value="2" style={styles.SelectMenu}>
									Yesterday
                                </MenuItem>
								<MenuItem value="7" style={styles.SelectMenu}>
									Last 7 days
                                </MenuItem>
								<MenuItem value="14" style={styles.SelectMenu}>
									Last 14 days
                                </MenuItem>
								<MenuItem value="28" style={styles.SelectMenu}>
									Last 28 days
                                </MenuItem>
								<MenuItem value="custom" style={styles.SelectMenu}>
									Custom
                                </MenuItem>
							</Select>
							{showCustomTimespan && <TextField
								id="custom_timestamp"
								label="Custom Timespan"
								name="custom_timestamp"
								value={customTimespan}
								onInput={this.handleCustomTimespanChange}
								margin="normal"
								type='number'
							/>}
							<InputLabel htmlFor="stage-select">
								Game Mode
                            </InputLabel>
							<Select
								style={styles.Select}
								value={gamemode}
								onChange={this.handleGamemodeChange}
								autoWidth
							>
								<MenuItem value="0" style={styles.SelectMenu}>
									All
                                </MenuItem>
								<MenuItem value="story-mode" style={styles.SelectMenu}>
									Story mode
                                </MenuItem>
								<MenuItem value="challenge-mode" style={styles.SelectMenu}>
									Challenge mode
                                </MenuItem>
							</Select>
						</div>
					</div>
					{
						players && players.data.length ?
							<Table className={this.classes.table}>
								<EnhancedTableHead
									rows={this.rows}
									order={order}
									orderBy={orderBy}
									onRequestSort={this.handleRequestSort}
								/>
								<TableBody>
									{this.renderPlayersList()}
								</TableBody>
							</Table>
							: null
					}
					<ReportChart open={openChart} onClose={this.handleCloseChart} options={chartOptions} />
				</div>
		)
	}

}

class ChallengeDetailsComponent extends Component {
	state = {
		challengeData: {},
		isFetching: false,
		openChart: false,
		chartOptions: {},
		source: 'last',
		representation: 'colours',
		order: 'asc',
		orderBy: 'name',
	}

	classes = this.props.classes;

	componentWillMount() {
		this.getPlayers(1, this.props.accountId, this.props.classRoomId)
	}

	componentWillReceiveProps(props) {
		if (props.classRoomId !== undefined) {
			this.getPlayers(1, props.accountId, props.classRoomId)
		}
	}

	getPlayers = (page, accountId, classRoomId) => {
		this.setState({ isFetching: true })
		return get(`/admin/reports/challenge-details?page=${page}&accountId=${accountId}&classRoomId=${classRoomId ? classRoomId : ''}`, token).then(res => {
			let challengeData = res.data
			this.setState({ challengeData, isFetching: false })
		})
	}

	handleOpenChart = (chartOptions) => {
		this.setState({ openChart: true, chartOptions })
	}
	handleCloseChart = () => {
		this.setState({ openChart: false, chartOptions: {} })
	}

	renderPlayersList = () => {
		const { source, representation } = this.state
		let challengeData = this.state.challengeData ?
			this.state.challengeData : []
		const colorSettings = challengeData.color_settings
		let result = []

		this.sortData(challengeData.data).map(item => {
			result.push(
				<TableRow
					className={this.classes.tableRow}
					key={item.id}
					/* onClick={() => this.props.toUsers(item.id)} */>
					<TableCell padding='none'>
						{item.name}
					</TableCell>
					{item.progress.map((data, index) => {
						let score = null

						if (source === 'first' && data.first !== 0) {
							score = data.first
						} else if (source === 'last' && data.last !== 0) {
							score = data.last
						} else if (source === 'change' && (data.first !== 0 || data.last !== 0)) {
							score = data.last - data.first
						}

						let color = ''
						if (source === 'change') {
							if (score < 0) {
								color = 'red'
							} else if (score === 0) {
								color = 'yellow'
							} else {
								color = 'green'
							}
						} else {
							if (score > 0 && score < colorSettings.yellow) {
								color = 'red'
							} else if (score >= colorSettings.yellow && score < colorSettings.green) {
								color = 'yellow'
							} else {
								color = 'green'
							}
						}

						return (
							score != null ? <TableCell
								className={this.classes.tableCellWithAction}
								padding='none'
								onClick={() => this.handleOpenChart({
									fetchFilters: { user_id: item.id, stage_id: challengeData.challenge_id, level_id: challengeData.levels[index].id },
									value: data => data.score_avg,
									settings: {}
								})}>
								{representation === 'colours' ? <Icon className={this.classes['rating-' + color]} >brightness_1</Icon> : <span>{score}</span>}
							</TableCell> :
								<TableCell padding='none'>
									<Icon >remove</Icon>
								</TableCell>
						)
					})}
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	handleSourceChange = (event) => {
		this.setState({ source: event.target.value })
	}

	handleRepresentationChange = (event) => {
		this.setState({ representation: event.target.value })
	}

	handleRequestSort = (event, property) => {
		const orderBy = property
		let order = 'desc'

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc'
		}

		this.setState({ order, orderBy })
	}

	sortData = (data) => {
		const { order, orderBy, source, representation } = this.state
		const challengeData = this.state.challengeData ?
			this.state.challengeData : []
		if(orderBy === 'name'){
			return data.sort((a, b) => {
				if (order === 'desc') {
					return a[orderBy] > b[orderBy] ? 1 : -1
				} else {
					return a[orderBy] > b[orderBy] ? -1 : 1
				}
			})
		}else{
			let levelIndex = 0
			challengeData.levels.forEach((level, index) => {
				if(level.id === orderBy){
					levelIndex = index
				}
			})
			return data.sort((a, b) => {
				if (order === 'desc') {
					if (source === 'first' && data.first !== 0) {
						return a.progress[levelIndex].first >= b.progress[levelIndex].first ? 1 : -1
					} else if (source === 'last' && data.last !== 0) {
						return a.progress[levelIndex].last >= b.progress[levelIndex].last ? 1 : -1
					} else if (source === 'change' && (data.first !== 0 || data.last !== 0)) {
						return a.progress[levelIndex].last - a.progress[levelIndex].first 
							>= b.progress[levelIndex].last - b.progress[levelIndex].first ? 1 : -1
					}
				} else {
					if (source === 'first' && data.first !== 0) {
						return a.progress[levelIndex].first >= b.progress[levelIndex].first ? -1 : 1
					} else if (source === 'last' && data.last !== 0) {
						return a.progress[levelIndex].last >= b.progress[levelIndex].last ? -1 : 1
					} else if (source === 'change' && (data.first !== 0 || data.last !== 0)) {
						return a.progress[levelIndex].last - a.progress[levelIndex].first 
							>= b.progress[levelIndex].last - b.progress[levelIndex].first ? -1 : 1
					}
				}
			})
		}
		
	}

	render() {
		const { order, orderBy, challengeData, isFetching, openChart, chartOptions, source, representation } = this.state
		const rows = [
			{
				id: 'name',
				title: 'NAME',
				sortable: true
			}
		]
		if(!isFetching && challengeData.levels){
			challengeData.levels.forEach(level => {
				rows.push({
					id: level.id,
					title: level.description.toUpperCase(),
					sortable: true
				})
			})
		}
		
		return (
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress className={this.classes.progress} size={50} />
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					<div className={this.classes.titleWrap}>
						<h2 className={this.props.classes.title}>Challenge Mode Learning Objectives Report</h2>
						<div>
							<InputLabel htmlFor="stage-select">
								Source
                            </InputLabel>
							<Select
								style={styles.Select}
								value={source}
								onChange={this.handleSourceChange}
								autoWidth
							>
								<MenuItem value="last" style={styles.SelectMenu}>
									Most recent score
                                </MenuItem>
								<MenuItem value="first" style={styles.SelectMenu}>
									First ever score
                                </MenuItem>
								<MenuItem value="change" style={styles.SelectMenu}>
									Change
                                </MenuItem>
							</Select>
							<InputLabel htmlFor="stage-select">
								Representation
                            </InputLabel>
							<Select
								style={styles.Select}
								value={representation}
								onChange={this.handleRepresentationChange}
								autoWidth
							>
								<MenuItem value="colours" style={styles.SelectMenu}>
									Display as colour coding
                                </MenuItem>
								<MenuItem value="numbers" style={styles.SelectMenu}>
									Display as numbers
                                </MenuItem>
							</Select>
						</div>
					</div>
					{
						challengeData && challengeData.data.length ?
							<Table className={this.classes.table}>
								{/* <TableHead>
									<TableRow>
										<TableCell padding='none'>
											NAME
										</TableCell>
										{challengeData.levels.map(level => {
											return (
												<TableCell padding='none'>
													<div className={this.classes.vertical}>{level.description}</div>
												</TableCell>
											)
										})}
									</TableRow>
								</TableHead> */}
								<EnhancedTableHead
									rows={rows}
									order={order}
									orderBy={orderBy}
									onRequestSort={this.handleRequestSort}
								/>
								<TableBody>
									{this.renderPlayersList()}
								</TableBody>
							</Table>
							: null
					}
					<ReportChart open={openChart} onClose={this.handleCloseChart} options={chartOptions} />
				</div>
		)
	}

}

class EnhancedTableHead extends React.Component {
	createSortHandler = property => event => {
		this.props.onRequestSort(event, property);
	};

	render() {
		const { order, orderBy, rows } = this.props;

		return (
			<TableHead>
				<TableRow>
					{rows.map(row => {
						return (
							<TableCell
								key={row.id}
								padding='none'
								sortDirection={orderBy === row.id ? order : false}
							>
								{row.sortable ? <TableSortLabel
									active={orderBy === row.id}
									direction={order}
									onClick={this.createSortHandler(row.id)}
								>
									{row.title}
								</TableSortLabel> : row.title}
							</TableCell>
						);
					}, this)}
				</TableRow>
			</TableHead>
		);
	}
}

class ReportChartComponent extends React.Component {
	state = {
		filterString: '',
		isFetching: false,
		chartData: [],
		zoomDomain: null
	}
	classes = this.props.classes
	componentWillMount() {
		if (this.props.open)
			this.fetchData()
	}
	componentWillReceiveProps(props) {
		if (props.options && props.open) {
			let filterString = this.formatFilterString(props.options.fetchFilters)
			this.fetchData(filterString)
		}
	}
	handleZoom = (domain) => {
		this.setState({ zoomDomain: domain });
	}
	fetchData = (filterString = '') => {
		this.setState({ chartData: [], zoomDomain: null, isFetching: true })
		return get(`/admin/reports/plays?${filterString}`, token).then(res => {
			let data = res.data
			let chartData = this.formatData(data.data)
			this.setState({ chartData, isFetching: false })
		})
	}
	formatFilterString = (data) => {
		let keys = Object.keys(data)
		let formatted = ''

		keys.forEach(key => {
			formatted += `${key}=${data[key]}&`
		})
		return formatted
	}
	formatData = (data) => {
		const { options } = this.props
		return data.map(value => {
			return {
				x: value.finished_at,
				y: options.value instanceof Object ? options.value(value) : options.value
			}
		})
	}
	getData = () => {
		const { options } = this.props
		const { chartData, zoomDomain } = this.state
		const maxPoints = 100

		let filtered = [...chartData]
		if (options.settings) {
			if (options.settings.summ) {
				let prevDate = null
				chartData.forEach(item => {
					let filteredItem = null
					if (prevDate && moment(prevDate).format('MDYY') === moment(item.x).format('MDYY')) {
						filteredItem = filtered.pop()
						filteredItem.y += item.y
					}
					else {
						prevDate = item.x
						filteredItem = item
					}
					filtered.push(filteredItem)
				})
			}
		}
		//const reduceCount = Math.ceil(chartData.length / maxPoints)

		/* filtered = chartData.filter(
			(d, i) => {
				if(!zoomDomain)
					return true
					try{
						let timestamp = new Date(d.x).getTime()
						let timestampMin = new Date(zoomDomain.x[0]).getTime()
						let timestampMax = new Date(zoomDomain.x[1]).getTime()
						return timestamp >  timestampMin && timestamp < timestampMax
					}catch(err){
						return true
					}
			}) */

		/* if (filtered.length > maxPoints) {
			const k = Math.ceil(filtered.length / maxPoints);
			return filtered.filter(
				(d, i) => ((i % k) === 0)
			);
		} */
		return filtered;
	}
	render() {
		const { isFetching } = this.state
		return (
			<Dialog
				open={this.props.open}
				onClose={this.props.onClose}
				maxWidth={'lg'}
				style={{ minWidth: '500px' }}
			>
				<DialogContent>
					{!isFetching ? <div>
						<svg width="800" height="470" className={this.classes.svgContainer}>
							<VictoryChart width={800} height={470} scale={{ x: "time" }}
								containerComponent={
									<VictoryZoomContainer
										allowZoom={false}
										zoomDomain={this.state.zoomDomain}
										onZoomDomainChange={this.handleZoom}
									/>
								}
								standalone={false}
							>
								<VictoryAxis dependentAxis
									tickFormat={(y) => Math.round(y * 100) / 100}
									fixLabelOverlap={true}
								/>
								<VictoryAxis
									tickFormat={(x) => moment(x).format('DD/MM/YYYY')}
									fixLabelOverlap={true}
								/>
								<VictoryLine
									style={{
										data: { stroke: "tomato" }
									}}
									data={this.getData()}
									x="x"
									y="y"
								/>

							</VictoryChart>
						</svg>
						{/* <svg width="800" height="100" className={this.classes.svgContainer}>
							<VictoryChart
								padding={{ top: 0, left: 50, right: 50, bottom: 30 }}
								width={800} height={100}
								scale={{ x: "linear", y: 'linear' }}
								containerComponent={
									<VictoryBrushContainer
										//brushDimension="x"
										brushDomain={this.state.zoomDomain}
										onBrushDomainChange={this.handleZoom}
									/>
								}
								standalone={false}
							>
								<VictoryAxis
									tickFormat={(x) => moment(x).format('DD/MM/YYYY')}
									fixLabelOverlap={true}
								/>
								<VictoryLine
									style={{
										data: { stroke: "tomato" }
									}}
									data={this.getData()}
									x="x"
									y="y"
								/>
							</VictoryChart>
						</svg> */}
					</div> :
						<div className={this.classes.progressWrapper}>
							<CircularProgress className={this.classes.progress} size={50} />
						</div>
					}
				</DialogContent>
			</Dialog>
		);
	}
}

class LevelPreviewComponent extends React.Component {
	classes = this.props.classes;
	render() {
		const level = this.props.level
		return (
			<Dialog
				maxWidth='md'
				open={true}
				onClose={this.props.onClose}>
				<DialogTitle>
					<Icon
						className={this.classes.closeIcon}
						onClick={this.props.onClose}>
						close
							</Icon>
					<br />
					<h2>{level.current_stage_name} {level.current_level}</h2>
					<h3>{level.current_level_data.description}</h3>
					<p>{level.current_level_data.instruction}</p>
						</DialogTitle>
				{level.current_level_data.id && <DialogActions className={this.classes.justifyCenter}>
					<LevelComponent level={level.current_level_data} />
				</DialogActions>}
			</Dialog>
		)
	}
}

const LevelPreview = withStyles(styles)(LevelPreviewComponent);

export const StoryMode = withStyles(styles)(StoryModeComponent);
export const ChallengeMode = withStyles(styles)(ChallengeModeComponent);
export const Effort = withStyles(styles)(EffortComponent);
export const ChallengeDetails = withStyles(styles)(ChallengeDetailsComponent);
export const ReportChart = withStyles(styles)(ReportChartComponent);



// WEBPACK FOOTER //
// ./src/components/content/ReportComponents.js